import TypographyStyles from 'components/Typography'
import styled from 'styled-components'

export const Title = styled(TypographyStyles)`
  margin-bottom: 30px;
  font-size: 16px;
  color: #868e96;
`
